export default "__VITE_ASSET__ea04503e__"